module.exports = __webpack_public_path__ + "static/office_conf_room-d4e54c82e984e929fe8c0aa9d8a24573.jpg";